import { WidgetVersionsIndex } from '@/models/widget';

/**
 * The version the editor offers first: the one the index flags as default.
 *
 * The fallbacks only matter for an index that names a default it does not
 * list — an authoring slip on the portal side that should still leave the
 * editor usable, preferably on a version that is not deprecated.
 */
export const resolveDefaultVersion = (
    index: WidgetVersionsIndex
): string | undefined => {
    const { versions } = index;
    const flagged = versions.find(({ version }) => version === index.default);
    return (
        flagged ??
        versions.find(({ deprecated }) => !deprecated) ??
        versions[0]
    )?.version;
};

/**
 * A file inside a version's directory. String-joined rather than `new URL` so
 * it also works on the relative dev-proxy root; `root` must end with `/`.
 */
export const widgetVersionPath = (
    root: string,
    version: string,
    file: string
): string => `${root}${version}/${file}`;

/**
 * Absolute URL of a version's module entry. The manifest's paths are relative
 * to its own directory, so the entry resolves against the version directory,
 * not against the widgets root.
 */
export const resolveEntryUrl = (
    baseUrl: string,
    version: string,
    entry: string
): string => new URL(entry, widgetVersionPath(baseUrl, version, '')).href;
